<template>
	<div class="certs">
		<div class="swiper-container swiper2">
			<div class="swiper-wrapper">
				<div class="swiper-slide"><img src="../assets/image/z1.jpg" alt="" class="zs-img"></div>
				<div class="swiper-slide"><img src="../assets/image/z2.jpg" alt="" class="zs-img"></div>
				<div class="swiper-slide"><img src="../assets/image/z3.jpg" alt="" class="zs-img"></div>
				<div class="swiper-slide"><img src="../assets/image/z4.jpg" alt="" class="zs-img"></div>
				<div class="swiper-slide"><img src="../assets/image/z5.jpg" alt="" class="zs-img"></div>
				<div class="swiper-slide"><img src="../assets/image/z6.jpg" alt="" class="zs-img"></div>
				<div class="swiper-slide"><img src="../assets/image/z7.jpg" alt="" class="zs-img"></div>
				<div class="swiper-slide"><img src="../assets/image/z8.jpg" alt="" class="zs-img"></div>
				<div class="swiper-slide"><img src="../assets/image/z9.jpg" alt="" class="zs-img"></div>
				<div class="swiper-slide"><img src="../assets/image/z10.jpg" alt="" class="zs-img"></div>
				<div class="swiper-slide"><img src="../assets/image/z11.jpg" alt="" class="zs-img"></div>
				<div class="swiper-slide"><img src="../assets/image/z12.jpg" alt="" class="zs-img"></div>
				<div class="swiper-slide"><img src="../assets/image/z13.jpg" alt="" class="zs-img"></div>

			</div>
			<div class="swiper-button-next"></div>
			<div class="swiper-button-prev"></div>
			<div class="swiper-pagination"></div>
		</div>
		
		<div class="swiper-container swiper2-m">
			<div class="swiper-wrapper">
				<div class="swiper-slide"><img src="../assets/image/z1.jpg" alt=""></div>
				<div class="swiper-slide"><img src="../assets/image/z2.jpg" alt=""></div>
				<div class="swiper-slide"><img src="../assets/image/z3.jpg" alt=""></div>
				<div class="swiper-slide"><img src="../assets/image/z4.jpg" alt=""></div>
				<div class="swiper-slide"><img src="../assets/image/z5.jpg" alt=""></div>
				<div class="swiper-slide"><img src="../assets/image/z6.jpg" alt=""></div>
				<div class="swiper-slide"><img src="../assets/image/z7.jpg" alt=""></div>
				<div class="swiper-slide"><img src="../assets/image/z8.jpg" alt=""></div>
				<div class="swiper-slide"><img src="../assets/image/z9.jpg" alt=""></div>
				<div class="swiper-slide"><img src="../assets/image/z10.jpg" alt=""></div>
				<div class="swiper-slide"><img src="../assets/image/z11.jpg" alt=""></div>
				<div class="swiper-slide"><img src="../assets/image/z12.jpg" alt=""></div>
				<div class="swiper-slide"><img src="../assets/image/z13.jpg" alt=""></div>
			</div>
			<div class="swiper-button-next"></div>
			<div class="swiper-button-prev"></div>
			<div class="swiper-pagination"></div>
		</div>
	</div>
	
</template>

<script>
	import Swiper from 'swiper'
	import 'swiper/css/swiper.min.css'
	export default {
		name: 'Certs',
		mounted() {
			//	证书轮播
			new Swiper('.swiper2', {
				slidesPerView: 5,
				spaceBetween: 10,
				centeredSlides: true,
				loop: true,
				navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev',
				},

				pagination: {
					el: '.swiper-pagination',
					clickable: true,
				},
			});
			//手机端
			new Swiper('.swiper2-m', {
				slidesPerView: 3,
				spaceBetween: 10,
				centeredSlides: true,
				loop: true,
				navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev',
				},
			
				pagination: {
					el: '.swiper-pagination',
					clickable: true,
				},
			});
		}
	}
</script>

<style lang="less">
	@import '../assets/css/main.less';

	.certs {
		width: 100%;
		/* overflow: hidden; */
		padding-bottom: @secction-padding;
		/* padding-top: 50px; */
		/* .swiper-container{
			overflow:visible!important ;
		} */
		.swiper2-m{
			display: none;
		}		
		.swiper2, .swiper2-m{
			padding-left: 30px;
			padding-right: 30px;

			.swiper-slide {
				text-align: center;
				display: -webkit-box;
				display: -ms-flexbox;
				display: -webkit-flex;
				display: flex;
				-webkit-box-pack: center;
				-ms-flex-pack: center;
				-webkit-justify-content: center;
				justify-content: center;
				-webkit-box-align: center;
				-ms-flex-align: center;
				-webkit-align-items: center;
				align-items: center;
				transition: 300ms;
				transform: scale(0.8);
				padding-bottom: 50px;
			}

			.swiper-button-prev,
			.swiper-container-rtl .swiper-button-next {
				left: 0px;
				right: auto;
			}

			.swiper-button-next,
			.swiper-container-rtl .swiper-button-prev {
				right: 0px;
				left: auto;
			}

			.swiper-slide-active,
			.swiper-slide-duplicate-active {
				transform: scale(1);
			}

			.swiper-pagination-bullet {
				width: 10px;
				height: 10px;
				opacity: 0.9;
				background-color: #fff;
				border: 1px solid #ddd;
			}

			.swiper-pagination-bullet-active {
				background-color: @theme-color;
				opacity: 1;
			}
		}

	}
</style>
